
import Cookie from "../plugins/Cookie";

$(function () {
    const agree = Cookie.get('accept-cookies');
    const block = $('.accept-cookies');

    if (!agree && block.length) {
        block.removeClass('accept-cookies_hide');
    }

    $(document).on('click', '.js-accept-cookies', (e) => {
        e.preventDefault();
        Cookie.set('accept-cookies', 'true', { expires: 60 * 60 * 24 * 7 });
        block.addClass('accept-cookies_hide');
    });
});